
// Configuration de l'environnement pour Monaco Editor
(window as any).MonacoEnvironment = {
    getWorkerUrl: function(moduleId: string, label: string) {
        if (label === 'json') {
            return './assets/monaco/min/vs/language/json/json.worker.js';
        }
        if (label === 'css' || label === 'scss' || label === 'less') {
            return './assets/monaco/min/vs/language/css/css.worker.js';
        }
        if (label === 'html' || label === 'handlebars' || label === 'razor') {
            return './assets/monaco/min/vs/language/html/html.worker.js';
        }
        if (label === 'typescript' || label === 'javascript') {
            return './assets/monaco/min/vs/language/typescript/ts.worker.js';
        }
        return './assets/monaco/min/vs/editor/editor.worker.js';
    }
};

import 'reflect-metadata';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'ag-grid-enterprise';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));


